export function formatDateTime(isoString, lang) {
  if (!isoString) return;
  const date = new Date(isoString);

  let hours = date.getHours();
  let minutes = date.getMinutes();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear() % 100;


  hours = String(hours).padStart(2, '0');
  minutes = String(minutes).padStart(2, '0');
  day = String(day).padStart(2, '0');
  month = String(month).padStart(2, '0');
  year = String(year).padStart(2, '0');

  return lang === 'he' ? `${hours}:${minutes} ${day}/${month}/${year}` : `${day}/${month}/${year} ${hours}:${minutes} `;
};

export function formatDeliveryDate(isoString, lang) {
  const date = new Date(isoString);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear() % 100;
  let hours = date.getHours();
  let minutes = date.getMinutes();

  day = String(day).padStart(2, "0");
  month = String(month).padStart(2, "0");
  year = String(year).padStart(2, "0");
  hours = String(hours).padStart(2, "0");
  minutes = String(minutes).padStart(2, "0");

  return lang === 'he' ? `${hours}:${minutes} | ${day}/${month}/${year}` : `${day}/${month}/${year} | ${hours}:${minutes}`;
}
